import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
        theme: {
                options: { customProperties: true },
                dark: false,
                themes: {
                        light: {
                                primary: '#03624c',
                                secondary: '#2cc295',         // Mint
                                accent: '#8c9eff',
                                error: '#b71c1c',
                                success: '#2cc295',           // Mint
                                black: '#000',
                                white: '#fff',
                                white_1: '#FCFDFC',
                                lightBlue: '#547D9A',
                                'light-grey': '#eee',
                                'light-grey2': '#F6F6F6',
                                'mid-grey': '#646464',
                                'mid-grey2': '#4B4B4B',
                                'dark-grey': '#CDCDCD',
                                'bg_Greeny_Gray': '#e8e8e8',
                                'bg_title': '#edf0f2',
                                'bg_title_lighter': '#f5f7f9',
                                'bg_highlight': '#e8f5e8',
                                'grey-500': '#4F4F4F',
                                'normal-grey': '#727272',
                                infoColor: '#FBBD1C',

                                colored_bg: '#f3f5f2',

                                bg1: '#f3f3f3',
                                bg2: '#fcfcfc',
                                bg3: '#fefefe',
                                bg4: '#2c2c2c',
                                bg5: '#898989',
                                bg6: '#4F4F4F',
                                bg7: '#e7e7e7',
                                bg8: '#e7e7e7',
                                bg_force_white: '#fff',
                                bg_force_black: '#000000',
                                bg_force_Grey: '#d7d7d7',
                                info: '#03624c',
                                golden: '#d2a000',
                                light_Primary: '#e6f2ef',
                                light_Primary2: '#edf5f3',
                                light_Primary3: '#e6f2ef',
                                blue: '#547D9A',
                                blue2: '#3377A7',
                                grey: '#484848',
                                force_grey: "#212121",
                                kanban_card_bg_color: '#ffffff',
                                task_color: '#547d9a',
                                white_GreenyGray: '#ffffff',
                                very_light_green: "#edf5f3",
                                light_dark_green: "#b8e0d6",
                                purple: '#665B9B',
                                text: '#484848',
                                text_secondary: '#C8C8C8',
                        },
                        dark: {
                                primary: '#03624c',
                                secondary: '#2cc295',         // Mint
                                black: '#fff',
                                error: '#b71c1c',
                                accent: '#8c9eff',
                                success: '#2cc295',           // Mint
                                white: '#000',
                                white_1: '#171816',
                                lightBlue: '#547D9A',
                                'light-grey': '#333',
                                'light-grey2': '#2D2E2D',
                                'mid-grey': '#CDCDCD',
                                'mid-grey2': '#CDCDCD',
                                'dark-grey': '#CDCDCD',
                                'bg_Greeny_Gray': '#252821',
                                'bg_title': '#1f211d',
                                'bg_title_lighter': '#1f211d',
                                'bg_highlight': '#1f211d',
                                infoColor: '#FBBD1C',
                                'grey-500': '#fff',
                                'normal-grey': '#C8C8C8',
                                colored_bg: '#353535',
                                bg1: '#202020',
                                bg2: '#171816',
                                bg3: '#303030',
                                bg4: '#2c2c2c',
                                bg5: '#f7f7f7',
                                bg6: '#FAFAFB',
                                bg7: '#464646',
                                bg8: '#292828',
                                bg_force_white: '#fff',
                                bg_force_black: '#000000',
                                bg_force_Grey: '#d7d7d7',
                                info: '#03624c',
                                golden: '#d2a000',
                                light_Primary: '#e6f2ef',
                                light_Primary2: '#edf5f3',
                                light_Primary3: '#1a2926',
                                blue: '#547D9A',
                                blue2: '#3377A7',
                                grey: '#EDEDED',
                                force_grey: "#212121",
                                kanban_card_bg_color: '#232322',
                                task_color: '#547d9a',
                                white_GreenyGray: '#232322',
                                very_light_green: "#edf5f3",
                                light_dark_green: "#b8e0d6",
                                purple: '#665B9B',
                                text: '#fff',
                                text_secondary: '#C8C8C8',
                        },
                },
        },
});
